export const HIL_SEGMENT_REASON_TEMPLATE_PENDING_APPROVAL =
  'TEMPLATE_PENDING_APPROVAL';

export const HIL_SEGMENTS_OPEN_RESOLVE_ACTIONS = 'open_resolve_actions_modal';

export const HIL_SEGMENTS_RETRY = 'retry_segment_attention';

export type SegmentAttentionContext = {
  segment_name: string;
  reason_code: string;
  issue: string;
};

export function extractTemplateIdsFromSegmentRow(row: unknown): string[] {
  if (!row || typeof row !== 'object') return [];
  const record = row as { metadata?: unknown };
  const metadata = record.metadata;
  if (!metadata || typeof metadata !== 'object') return [];
  const templateIds = (metadata as { template_ids?: unknown }).template_ids;
  if (!Array.isArray(templateIds)) return [];
  return Array.from(
    new Set(
      templateIds
        .map(id => (id == null ? '' : String(id).trim()))
        .filter(Boolean),
    ),
  );
}

export function extractSegmentAttentionContext(row: unknown): SegmentAttentionContext {
  if (!row || typeof row !== 'object') {
    return { segment_name: '', reason_code: '', issue: '' };
  }
  const record = row as {
    segment_name?: unknown;
    reason_code?: unknown;
    issue?: unknown;
    metadata?: unknown;
  };
  const segment_name = extractSegmentNameFromSegmentRow(row);
  const reason_code = getSegmentAttentionReasonCode(row);
  let issue = record.issue == null ? '' : String(record.issue).trim();
  if (!issue && record.metadata && typeof record.metadata === 'object') {
    const metaIssue = (record.metadata as { issue?: unknown }).issue;
    issue = metaIssue == null ? '' : String(metaIssue).trim();
  }
  return { segment_name, reason_code, issue };
}

export function getSegmentAttentionGridRowKey(row: unknown): string {
  if (!row || typeof row !== 'object') return '';
  const record = row as { __gridRowId?: unknown; _id?: unknown };
  if (record.__gridRowId != null && String(record.__gridRowId).trim()) {
    return String(record.__gridRowId).trim();
  }
  if (record._id != null && String(record._id).trim()) {
    return String(record._id).trim();
  }
  const segmentName = extractSegmentNameFromSegmentRow(row);
  const reasonCode = getSegmentAttentionReasonCode(row);
  if (segmentName && reasonCode) {
    return `${segmentName}::${reasonCode}`;
  }
  return '';
}

export function getSegmentAttentionImpactedCount(row: unknown): number {
  if (!row || typeof row !== 'object') return 1;
  const raw = (row as { impacted_count?: unknown }).impacted_count;
  const numeric = Number(raw);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : 1;
}

export function extractSegmentNameFromSegmentRow(row: unknown): string {
  if (!row || typeof row !== 'object') return '';
  const record = row as {
    segment_name?: unknown;
    metadata?: unknown;
  };
  const topLevel = record.segment_name;
  if (topLevel != null && String(topLevel).trim()) {
    return String(topLevel).trim();
  }
  const metadata = record.metadata;
  if (!metadata || typeof metadata !== 'object') return '';
  const metadataSegmentName = (metadata as { segment_name?: unknown }).segment_name;
  return metadataSegmentName == null ? '' : String(metadataSegmentName).trim();
}

export function getSegmentAttentionReasonCode(row: unknown): string {
  if (!row || typeof row !== 'object') return '';
  const reasonCode = (row as { reason_code?: unknown }).reason_code;
  return reasonCode == null ? '' : String(reasonCode).trim();
}
